module.exports = __webpack_public_path__ + "img/店铺排行3.d99c098d.png";